<section *ngIf="rol_social || cargando || error" class="iguau-amigos" aria-labelledby="iguau-amigos-titulo">
  <div class="iguau-amigos__header">
    <div class="iguau-amigos__heading">
      <span class="iguau-amigos__symbol" aria-hidden="true"><i class="fa-solid fa-user-group"></i></span>
      <div>
        <h3 id="iguau-amigos-titulo">Amigos <span class="iguau-amigos__count" *ngIf="!cargando && !error">{{ amigos.length }}</span></h3>
        <p>Personas y mascotas de tu comunidad</p>
      </div>
    </div>
    <div class="iguau-amigos__header-actions">
      <div *ngIf="!cargando && !error && amigos.length > 3" class="iguau-amigos__controls" aria-label="Navegar por los amigos">
        <button type="button" class="iguau-amigos__arrow" [disabled]="!puedeAnterior" (click)="navegar(-1)" aria-label="Ver los tres amigos anteriores" title="Anteriores"><i class="fa-solid fa-chevron-left" aria-hidden="true"></i></button>
        <button type="button" class="iguau-amigos__arrow" [disabled]="!puedeSiguiente" (click)="navegar(1)" aria-label="Ver los tres amigos siguientes" title="Siguientes"><i class="fa-solid fa-chevron-right" aria-hidden="true"></i></button>
      </div>
    <button *ngIf="error" type="button" class="iguau-amigos__retry" (click)="getRolPerfil()">
      <i class="fa-solid fa-rotate-right" aria-hidden="true"></i> Reintentar
    </button>
    </div>
  </div>

  <div *ngIf="cargando" class="iguau-amigos__grid" role="status" aria-label="Cargando amigos">
    <div class="iguau-amigos__skeleton" *ngFor="let item of [1,2,3]">
      <span class="iguau-amigos__skeleton-photo"></span><span class="iguau-amigos__skeleton-line"></span>
      <span class="iguau-amigos__skeleton-line short"></span>
    </div>
  </div>

  <div class="iguau-amigos__message" *ngIf="!cargando && error" role="alert">
    <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
    No hemos podido cargar tus amigos. Puedes intentarlo de nuevo.
  </div>

  <div class="iguau-amigos__message" *ngIf="!cargando && !error && !amigos.length">
    <i class="fa-regular fa-heart" aria-hidden="true"></i>
    Aún no hay amigos para mostrar.
  </div>

  <div #carrusel class="iguau-amigos__grid iguau-amigos__carousel" *ngIf="!cargando && !error && amigos.length" (scroll)="actualizarNavegacion()" aria-label="Galería de amigos">
    <a *ngFor="let amigo of amigos; trackBy: trackByAmigo"
       class="iguau-amigos__item" [href]="enlacePerfil(amigo)"
       [attr.aria-label]="'Ver perfil de ' + nombreUsuario(amigo) + ' y ' + nombreMascota(amigo)">
      <span class="iguau-amigos__photos">
        <img class="iguau-amigos__pet" [src]="fotoMascota(amigo)" [alt]="'Foto de ' + nombreMascota(amigo)" loading="lazy" />
        <img class="iguau-amigos__person" [src]="fotoUsuario(amigo)" [alt]="'Foto de ' + nombreUsuario(amigo)" loading="lazy" />
        <span *ngIf="amigo.online" class="iguau-amigos__online" title="En línea" aria-label="En línea"></span>
      </span>
      <strong class="iguau-amigos__pet-name" [title]="amigo?.mascota?.ma_nombre || ''">{{ nombreMascota(amigo) }}</strong>
      <span class="iguau-amigos__person-name" [title]="amigo?.first_name || ''">{{ nombreUsuario(amigo) }}</span>
    </a>
  </div>
</section>
